import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum FeatureFlagList {
  BFF = 'useBFF',
  DOCKET_LAYOUT = 'docketLayout',
}

export interface IFeatureFlag {
  docketLayout: boolean;
  useBFF: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  public featureFlagChanged: Subject<{
    flag: FeatureFlagList;
    value: boolean;
  }> = new Subject();

  private _featureFlags: IFeatureFlag;

  constructor() {
    this._featureFlags = {
      docketLayout: true,
      useBFF: true,
    };
  }

  /**
   * returns the on/off boolean state of a feature
   * @param flag the feature that is being flagged
   * @returns on/off as a boolean.
   */
  public isFeatureFlagEnabled(flag: FeatureFlagList | string): boolean {
    return this._featureFlags && this._featureFlags[flag];
  }

  /**
   * method to set a value of a flag
   * @param flag the flag to set
   * @param val  the new value
   */
  public setFeatureFlag(flag: FeatureFlagList, val: boolean): void {
    this._featureFlags[flag] = val;

    this.featureFlagChanged.next({
      flag: flag,
      value: val,
    });
  }
}
